import ShippingClientLayout from './ShippingClientLayout';
export default ShippingClientLayout;